// extracted by mini-css-extract-plugin
module.exports = {"keyBinding":"_1oC3O","recording":"FLApv","keys":"_2eKpk","a3643":"_3YOJA","keysWrapper":"_504-a","errorText":"_3X6BR","hidden":"b2F4U"};